import { ref, useRoute, useRouter } from "@nuxtjs/composition-api";
function useFilter() {
  const route = useRoute();
  const router = useRouter();
  const selectedFilters = ref({});
  const isFeatureFilter = (name) => {
    return typeof name !== "string";
  };
  const getFiltersFromURL = () => {
    const result = {};
    const { page, ...rest } = route.value.query;
    Object.entries(rest).forEach(([key, value]) => {
      result[key] = typeof value === "string" ? [value] : value;
    });
    selectedFilters.value = result;
  };
  const updateSelectedFilters = (value, name) => {
    const newSelectedFiltersKey = isFeatureFilter(name) ? "filters" : name;
    selectedFilters.value = {
      ...selectedFilters.value,
      [newSelectedFiltersKey]: [...value]
    };
  };
  const pushQueryToRoute = (params) => {
    router.push({
      query: {
        ...selectedFilters.value,
        ...params
      }
    });
  };
  const handleFilterChanged = ({ value, name }) => {
    updateSelectedFilters(value, name);
    pushQueryToRoute({ page: void 0 });
  };
  getFiltersFromURL();
  return {
    selectedFilters,
    getFiltersFromURL,
    updateSelectedFilters,
    pushQueryToRoute,
    handleFilterChanged
  };
}
;
export {
  useFilter as default
};
